/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordVerification
 */
export interface PasswordVerification {
    /**
     * 
     * @type {string}
     * @memberof PasswordVerification
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordVerification
     */
    code: string;
}

/**
 * Check if a given object implements the PasswordVerification interface.
 */
export function instanceOfPasswordVerification(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function PasswordVerificationFromJSON(json: any): PasswordVerification {
    return PasswordVerificationFromJSONTyped(json, false);
}

export function PasswordVerificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordVerification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': !exists(json, 'password') ? undefined : json['password'],
        'code': json['code'],
    };
}

export function PasswordVerificationToJSON(value?: PasswordVerification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
        'code': value.code,
    };
}

